export enum BadgeActionTypes {
	SET_ACTION_TYPE = 'SET_ACTION_TYPE',
	SET_GRAPHIC_TEXT = 'SET_GRAPHIC_TEXT',
	SET_BADGE_STUDIO_MAGSTRIPE = 'SET_BADGE_STUDIO_MAGSTRIPE',
	SET_VISUAL_SHAPE_OBJECT = 'SET_VISUAL_SHAPE_OBJECT',
	SET_BADGE_STUDIO_IMAGE = 'SET_BADGE_STUDIO_IMAGE',
	SET_BADGE_STUDIO_BARCODE = 'SET_BADGE_STUDIO_BARCODE',
	SET_BADGE_STUDIO_INFO = 'SET_BADGE_STUDIO_INFO',
	SET_FONTS = 'SET_FONTS',
	SET_UDFS = 'SET_UDFS',
	SET_UDFS_256 = 'SET_UDFS_256',
	SET_SPACE_OBJECT_DATA = 'SET_SPACE_OBJECT_DATA',
	SET_CURRENT_REDLINE_CONFIG_VALUES = 'SET_CURRENT_REDLINE_CONFIG_VALUES',
	SET_GRAPHIC_DATA = 'SET_GRAPHIC_DATA',
	SET_DISABLE_MENU_OPTS = 'SET_DISABLE_MENU_OPTS',
	SET_DROP_DATA_NODES = 'SET_DROP_DATA_NODES',
	SET_HAS_CHANGED = 'SET_HAS_CHANGED',
	SET_VIEW_MODE = 'SET_VIEW_MODE',
}
